const API_URL = 'https://api.u4u.app'
// const API_URL = 'http://localhost:8000'
export default API_URL
